module.exports = __webpack_public_path__ + "static/img/son2_active.d0a34598.png";